import { PatchOrderRequestedResponse } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum AdtCreateOrderActionTypes {
    PATCH_ORDER_CREATION = '[ADT] Patch Order Requested',
    LOAD_ORDER_CREATED = '[ADT] Load Order Created',
    RESET_ORDER = '[ADT] Reset Order',
}

/**
 * Patch order creation
 */
export class PatchOrderCreationAction implements Action {
    readonly type = AdtCreateOrderActionTypes.PATCH_ORDER_CREATION;

    constructor(public payload: number) { }
}

/**
 * Load order created
 */
export class LoadOrderCreatedAction implements Action {
    readonly type = AdtCreateOrderActionTypes.LOAD_ORDER_CREATED;

    constructor(public payload: PatchOrderRequestedResponse) { }
}

/**
 * Reset order
 */
export class AdtResetOrderAction implements Action {
    readonly type = AdtCreateOrderActionTypes.RESET_ORDER;
}

export type AdtCreateOrderActions =
    | PatchOrderCreationAction
    | LoadOrderCreatedAction
    | AdtResetOrderAction;
